import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import HelpText from '../../components/help/HelpText';

import { adminUser, renderErrorWarning, renderErrors, capitalizeAllWords } from '../../utilities/Forms.js'
import { hideResidentsCheck, TYPE_OF_PEOPLE } from '../../utilities/Generic.js'

import { faArrowsAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { DragDropContext, Draggable  } from 'react-beautiful-dnd';
import Droppable from '../../components/shared/StrictModeDroppable'
import {request, handleRequestErrors} from '../../helpers/Requests'

class UpdateFireLogSettings extends Component {

  constructor(props) {
    super(props);

    this.onDragEnd = this.onDragEnd.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    fire_log_order: TYPE_OF_PEOPLE,

    hideResidents: hideResidentsCheck(),

    loaded: false,
    unauthorized: "",
    error: "",
    errors: ""
  };

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const fire_log_order = this.reorder(
      this.state.fire_log_order,
      result.source.index,
      result.destination.index
    );

    this.setState({
      fire_log_order: fire_log_order
    });
  }

  handleSubmit(event) {
    this.setState({
      success: false,
      updating: true
    })

    let fire_log_order = this.state.fire_log_order

    if (this.state.hideResidents) {
      fire_log_order.push("resident")
    }

    var json = JSON.stringify({
      "organisation_settings": {
       "fire_log_order": fire_log_order
      }
    })

    request("PUT", `/v1/a/organisation_settings/0`, json, () => {this.setState({unauthorized: true})})
    .then(data => {
      this.setState({
        fire_log_order: data.fire_log_order,

        errors: "",
        updating: false
      })
      sessionStorage.setItem("updateSuccess", "Fire Log Settings updated successfully!");
      this.props.updatePopupCallback(Math.random())
    })
    .catch(error => handleRequestErrors(this, error, { loaded: true }))

    event.preventDefault();
  }

  renderSaveButton() {
    if (adminUser()) {
      return (
        <input className="top-padding" type="submit" disabled={this.state.updating} value="Save" />
      )
    }
    else {
      return <input className="top-padding" type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  indexBackground(index) {
    if (index % 2 === 0) {
      return "#eee"
    }
    else {
      return "#fff"
    }
  }

  render() {
    let { fire_log_order, loaded, unauthorized, errors, error } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/> 
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      const getItemStyle = (isDragging, draggableStyle, index) => ({
        backgroundColor: isDragging ? "lightgreen" : this.indexBackground(index),
        ...draggableStyle
      });

      return (
        <div>
          <form className="settings big-settings segment-settings top-padding" onSubmit={this.handleSubmit}>
            <div className="segment">
              <HelpText className="small-bottom-padding" page={'fire_log_settings'} section={'order'} />
              <br/>
              {renderErrors(errors, "fire_log_order")}
              <DragDropContext onDragEnd={this.onDragEnd} className="table big-table">
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <div {...provided.droppableProps} className="drag-and-drop" ref={provided.innerRef} >
                      <div className="row three-columns heading">
                        <div className="th"></div>
                        <div className="th">Order</div>
                        <div className="th">Type of Person</div>
                      </div>

                      {fire_log_order.map((type_of_person, index) => (
                        <Draggable key={`key-${type_of_person}`} draggableId={`key-${type_of_person}`} index={index}>
                          {(provided, snapshot) => (
                            <div id={type_of_person} className="row three-columns" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style, index)} >
                              <div className="td drag-icon"><FontAwesomeIcon icon={faArrowsAlt} /></div>
                              <div className="td">{index + 1}</div>
                              <div className="td">{capitalizeAllWords(type_of_person)}</div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              { this.renderSaveButton() }
              { renderErrorWarning(errors) }
            </div>
          </form>
        </div>
      );
    }
  }

  componentDidMount() {
    request("GET", `/v1/a/organisation_settings/0`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        let fire_log_order = data.fire_log_order

        if (this.state.hideResidents) {
          fire_log_order = fire_log_order.filter(type_of_person => type_of_person !== "resident")
        }

        this.setState({
          "fire_log_order": fire_log_order,

          loaded: true
        })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}


export default UpdateFireLogSettings;
